export const getArrayValue = (value: string | string[] | undefined): string[] | undefined => {
  if (value === undefined) {
    return undefined
  }

  return Array.isArray(value) ? value : [value]
}
